export const ROLES_EDITABLES = ['ANALISTA', 'COORDINADOR', 'GERENTE'] as const;
export type RolEditable = typeof ROLES_EDITABLES[number];

export const ROL_LABELS: Record<string, string> = {
  ADMIN: 'Administrador',
  ANALISTA: 'Analista',
  COORDINADOR: 'Coordinador',
  GERENTE: 'Gerente de Calidad',
};

export interface AccionPermiso {
  key: string;
  label: string;
  descripcion: string;
  grupo: string;
}

export const GRUPOS_PERMISOS = [
  'Gestión de Resultados',
  'Gestión de Informes y Pedidos',
  'Bitácoras y Contactos',
  'Catálogos',
] as const;

export const ACCIONES_PERMISOS: AccionPermiso[] = [
  {
    key: 'capturar_resultado',
    label: 'Capturar resultado',
    descripcion: 'Llenar un formulario de prueba por primera vez.',
    grupo: 'Gestión de Resultados',
  },
  {
    key: 'editar_resultado_borrador',
    label: 'Editar resultado en borrador',
    descripcion: 'Modificar una prueba que aún no fue aceptada ni rechazada.',
    grupo: 'Gestión de Resultados',
  },
  {
    key: 'aprobar_rechazar_resultado',
    label: 'Aprobar / Rechazar resultado',
    descripcion: 'Revisar una prueba ya capturada y aceptarla o rechazarla con motivo.',
    grupo: 'Gestión de Resultados',
  },
  {
    key: 'autorizar_informe',
    label: 'Autorizar informe',
    descripcion: 'Dar el visto bueno final para emitir el informe de resultados.',
    grupo: 'Gestión de Informes y Pedidos',
  },
  {
    key: 'cerrar_pedido',
    label: 'Cerrar pedido',
    descripcion: 'Finalizar la carga de pruebas y generar los reportes oficiales.',
    grupo: 'Gestión de Informes y Pedidos',
  },
  {
    key: 'reabrir',
    label: 'Reabrir pedido',
    descripcion: 'Reabrir un pedido ya cerrado, con o sin trazabilidad.',
    grupo: 'Gestión de Informes y Pedidos',
  },
  {
    key: 'ver_bitacoras',
    label: 'Ver bitácoras',
    descripcion: 'Consultar y descargar la bitácora interna de un pedido.',
    grupo: 'Bitácoras y Contactos',
  },
  {
    key: 'ver_contactos',
    label: 'Ver contactos',
    descripcion: 'Consultar los datos de contacto de los clientes.',
    grupo: 'Bitácoras y Contactos',
  },
  {
    key: 'editar_contactos',
    label: 'Editar contactos',
    descripcion: 'Modificar los datos de contacto de los clientes.',
    grupo: 'Bitácoras y Contactos',
  },
  {
    key: 'administrar_catalogo',
    label: 'Administrar catálogo de pruebas',
    descripcion: 'Agregar o editar las pruebas disponibles en el catálogo.',
    grupo: 'Catálogos',
  },
];
